import React from 'react';

import OnTraccrCheckbox from '../common/inputs/OnTraccrCheckbox';
import HoverHelp from '../common/HoverHelp';

/** Supports both form-field shape (selectedType/configProps) and flattened card shape (type/dataType). */
export const isMaterialsTableField = (record) => (
  (record?.selectedType === 'table' && record?.configProps?.dataType === 'Materials')
  || (record?.type === 'table' && record?.dataType === 'Materials')
);

/**
 * Ant Design table column for the "Reset Date Added?" materials mapping setting.
 * @param {Object} valueMap - { [fieldId]: boolean }
 * @param {(recordId: string, checked: boolean) => void} onChange
 * @param {(record: Object) => string} [getRecordId]
 */
export const getResetMaterialsAddedDateColumn = ({
  valueMap = {},
  onChange,
  getRecordId = (record) => record.id ?? record.key,
}) => ({
  dataIndex: 'resetMaterialsAddedDate',
  title: (
    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      Reset Date Added?
      <HoverHelp
        content={(
          <div style={{ width: 300 }}>
            When checked, each mapped materials row's <strong>Date Added</strong> is set to the
            date the mapping happens, instead of keeping the source row's original <strong>Date Added</strong> date.
          </div>
        )}
      />
    </span>
  ),
  width: 150,
  render: (_, record) => {
    if (!isMaterialsTableField(record)) {
      return '—';
    }
    const recordId = getRecordId(record);
    return (
      <OnTraccrCheckbox
        value={!!valueMap[recordId]}
        onChange={(checked) => onChange(recordId, checked)}
      />
    );
  },
});
